<div>
    @if (loaded()) {
    <app-portal-menu class="app-top mat-typography">

        @if (error()) {
            {{ error() }}
        }

        @if ($dashboard()) {
        <eas-board [boardJSON]="$dashboard()?.doc.board" [boardId]="$dashboard()?.doc._id"></eas-board>
        }

        <mat-card appearance="outlined" id="app-footer">
          <mat-card-content>
            <app-version-information></app-version-information>
            <router-outlet name="footer"></router-outlet>
          </mat-card-content>
        </mat-card>
      </app-portal-menu>
    }
 </div>